<div class="p-6 card-style-full">
  <div class="flex justify-between items-center mb-4">
    <h2 class="text-gray-700 font-bold">Editar motorista — {{ data.motorista.nome }}</h2>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div [formGroup]="form" class="flex flex-col gap-3">
    <div class="flex gap-4">
      <mat-form-field class="input-tg flex-1" appearance="outline">
        <mat-label>Contato (celular) *</mat-label>
        <input matInput formControlName="contato" />
      </mat-form-field>
    </div>

    <h4>Habilitação</h4>
    <div class="flex gap-4">
      <mat-form-field class="input-tg" style="width:120px" appearance="outline">
        <mat-label>Categoria</mat-label>
        <mat-select formControlName="categoria">
          @for (item of listCategory; track item.id) {
            <mat-option [value]="item.id">{{ item.description }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg flex-1" appearance="outline">
        <mat-label>N° registro</mat-label>
        <input matInput formControlName="numeroRegistro" />
      </mat-form-field>
      <mat-form-field class="input-tg" style="width:160px" appearance="outline">
        <mat-label>Validade CNH *</mat-label>
        <input matInput [matDatepicker]="validadePicker" (focus)="validadePicker.open()" formControlName="validade" />
        <mat-datepicker-toggle matIconSuffix [for]="validadePicker"></mat-datepicker-toggle>
        <mat-datepicker #validadePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <mat-slide-toggle color="primary" formControlName="antecedentesCriminais">
      Antecedentes criminais verificados
    </mat-slide-toggle>

    @if (form.get('antecedentesCriminais')?.value) {
      <mat-form-field class="input-tg" style="width:200px" appearance="outline">
        <mat-label>Validade antecedentes</mat-label>
        <input matInput [matDatepicker]="antecedentesPicker" (focus)="antecedentesPicker.open()" formControlName="antecedentesValidade" />
        <mat-datepicker-toggle matIconSuffix [for]="antecedentesPicker"></mat-datepicker-toggle>
        <mat-datepicker #antecedentesPicker></mat-datepicker>
      </mat-form-field>
    }

    <div class="flex justify-end mt-2">
      <button
        mat-flat-button class="btn-tg"
        [disabled]="form.invalid || saving"
        (click)="save()"
      >
        @if (saving) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          Salvar
        }
      </button>
    </div>

    <h4 class="mt-2">Documentos</h4>
    <supplier-portal-documents [escopo]="'motorista'" [ownerId]="data.motorista.id" />
  </div>
</div>
